// extracted by mini-css-extract-plugin
export default {"whatIsPCP":"responsiveStyles_whatIsPCP__Kiys-","twoCols":"responsiveStyles_twoCols__0gN+Q"};